"use client";
import "./bangkeo-favorite.scss";
import React, { useEffect, lazy } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { ADD_FAVORITE_MATCH, ADD_FAVORITE_LEAGUE } from "@/lib/redux/reducers/actionTypes";
import Favicon from "@/public/Favicon.svg";
import { Link } from '@/lib/target';
import { Image } from '@/lib/target';
import { SET_FAVORITE_TYPE_ROUTE, SET_FIXTURES_ROUTE } from "@/lib/redux/reducers/actionTypes";
import { UserService } from "../../../services/userService";
import ARROW_RIGHT_WHITE from "@/assets/images/arrow_right_white.svg";

const BangkeoFavoriteLeague = lazy(() => import('@/components/client/BangkeoFavoriteLeague'));
const BangkeoFavoriteFixture = lazy(() => import('@/components/client/BangkeoFavoriteFixture'));

const BangkeoFavorite = () => {
  const companyIdOdds = useSelector((state) => state.bookmakerReducer);

  const updateFavoriteMatches = (matches) => {
    matches.map((match) => {
      dispatch({ type: ADD_FAVORITE_MATCH, payload: match });
    });
  };

  const updateFavoriteLeagues = (leagues) => {
    leagues.map((league) => {
      dispatch({ type: ADD_FAVORITE_LEAGUE, payload: league });
    });
  };

  const dateSelected = useSelector((state) => state.searchReducer.dateSelected);
  const favoriteMatches = useSelector((state) => state.favoriteReducer.favoriteMatches);
  const favoriteLeagues = useSelector((state) => state.favoriteReducer.favoriteLeagues);
  const favoriteTeams = useSelector((state) => state.favoriteReducer.favoriteTeams);

  const dispatch = useDispatch();
 
  const handleClickTaiday = () => {
   dispatch({ type: SET_FIXTURES_ROUTE, payload: 'tatca' });
  }

  useEffect(() => {
    const fetchFavorites = async () => {
      let matchIds = favoriteMatches?.reduce((acc, match) => {
        acc.push(match.id);
        return acc;
      }, []);
  
      let leagueIds = favoriteLeagues?.reduce((acc, league) => {
        acc.push(league.id);
        return acc;
      }, []);
  
      try {
        const data = await UserService.fetchFavorites({
          matchIds: matchIds.join(","),
          matchInclude: "homeTeam,awayTeam,odds,stats,events",
          matchFilterOdds: companyIdOdds,
          leagueIds: leagueIds.join(","),
        });
        updateFavoriteMatches(data?.data?.data?.matches);
        updateFavoriteLeagues(data?.data?.data?.leagues);
      } catch (error) {
        console.error("Error fetching favorites:", error);
      }
    };

    fetchFavorites();

  }, [dateSelected]);

  const handleXemtatcaFixture = () => {
    dispatch({ type: SET_FAVORITE_TYPE_ROUTE, payload: 'favorite-matches' });
  }

  const handleXemtatcaLeague = () => {
    dispatch({ type: SET_FAVORITE_TYPE_ROUTE, payload: 'favorite-leagues' });
  }

  const handleXemtatcaTeam = () => {
    dispatch({ type: SET_FAVORITE_TYPE_ROUTE, payload: 'favorite-teams' });
  }

  return (
    <div className="bangkeo-favorite">
      <div className="match-favorite">
        <div className="h-8 rounded-l-md bg-button-blue-bet dark:bg-black flex rounded-md my-1 w-full justify-between gap-4 mb-2 @md:mb-0">
          <div className="flex">
            <div className="flex items-center p-2 gap-2">
              <p className="text-white text-[0.875rem]">Trận đấu yêu thích</p>
              <span className="bg-golden-yellow dark:bg-large-blue dark:text-stroke-o3 text-dark-gray text-[0.875rem] p-1 w-7 h-5 flex items-center justify-center rounded-full">{favoriteMatches?.length}</span>
            </div>
          </div>
          <div className="flex">
            <div className="flex items-center p-2 gap-2">
              <Link href={{ pathname: '/yeu-thich-fixture' }} className="flex flex-row items-center text-[0.75rem] text-white hover:cursor-pointer hover:text-white" onClick={handleXemtatcaFixture}>Xem tất cả
              <Image src={ARROW_RIGHT_WHITE} className="w-6 h-6" />
              </Link>
            </div>
          </div>
        </div>

        {favoriteMatches?.length === 0 && 
          <div className="flex flex-col items-center justify-center">
            <Image src={Favicon} className="w-[9rem] h-[7.375rem] my-4" />
            <p className="text-dark-gray text-[0.75rem]">Hôm nay bạn chưa có trận đấu yêu thích nào.</p>
            <p className="text-dark-gray text-[0.75rem] mb-4">Khám phá các trận đấu mà bạn có thể thích <span className="text-medium-blue hover:cursor-pointer" onClick={handleClickTaiday}>tại đây.</span></p>
          </div>
        }
        <BangkeoFavoriteFixture matches={favoriteMatches} />
      </div>

      {/* <div className="match-favorite">
        <div className="h-8 rounded-l-md bg-button-blue-bet flex rounded-md my-1 w-full justify-between gap-4">
          <div className="flex">
            <div className="flex items-center p-2 gap-2">
              <p className="text-white text-[0.875rem]">Đội bóng yêu thích</p>
              <span className="bg-golden-yellow text-dark-gray text-[0.875rem] p-1 w-7 h-5 flex items-center justify-center rounded-full">{favoriteTeams?.length}</span>
            </div>
          </div>
          <div className="flex">
            <div className="flex items-center p-2 gap-2">
              <Link href={{ pathname: '/yeu-thich-team' }} className="flex flex-row items-center text-[0.75rem] text-white hover:cursor-pointer hover:text-white" onClick={handleXemtatcaTeam}>Xem tất cả
              <Image src={ARROW_RIGHT_WHITE} className="w-6 h-6" />
              </Link>
            </div>
          </div>
        </div>
        {favoriteTeams?.length === 0 &&
          <div className="flex flex-col items-center justify-center">
            <Image src={Favicon} className="w-[9rem] h-[7.375rem] my-4" />
            <p className="text-dark-gray text-[0.75rem]">Hôm nay bạn chưa có đội bóng yêu thích nào.</p>
            <p className="text-dark-gray text-[0.75rem] mb-4">Khám phá các đội bóng mà bạn có thể thích <span className="text-medium-blue hover:cursor-pointer" onClick={handleClickTaiday}>tại đây.</span></p>
          </div>
        }
        <BangkeoFavoriteTeam />
      </div>  */}

      <div className="match-favorite">
        <div className="h-8 rounded-l-md bg-button-blue-bet dark:bg-black flex rounded-md my-1 w-full justify-between gap-4">
          <div className="flex">
            <div className="flex items-center p-2 gap-2">
              <p className="text-white dark:text-stroke-o3 text-[0.875rem]">Giải đấu yêu thích</p>
              <span className="bg-golden-yellow dark:bg-large-blue dark:text-stroke-o3 text-dark-gray text-[0.875rem] p-1 w-7 h-5 flex items-center justify-center rounded-full">{favoriteLeagues?.length}</span>
            </div>
          </div>
        </div>
        {favoriteLeagues?.length === 0 &&
          <div className="flex flex-col items-center justify-center">
            <Image src={Favicon} className="w-[9rem] h-[7.375rem] my-4" />
            <p className="text-dark-gray text-[0.75rem]">Hôm nay bạn chưa có giải đấu yêu thích nào.</p>
            <p className="text-dark-gray text-[0.75rem] mb-4">Khám phá các giải đấu mà bạn có thể thích <span className="text-medium-blue hover:cursor-pointer" onClick={handleClickTaiday}>tại đây.</span></p>
          </div>
        }
        <BangkeoFavoriteLeague leagues={favoriteLeagues}/>
        </div>
    </div>
  );
};

export default BangkeoFavorite;
